/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BookingType } from '../models/BookingType';
import type { NewTransportOptionEnum } from '../models/NewTransportOptionEnum';
import type { WorkshopCheckInCDKCheckOutCreateModel } from '../models/WorkshopCheckInCDKCheckOutCreateModel';
import type { WorkshopCheckInUploadedVideoResponseModel } from '../models/WorkshopCheckInUploadedVideoResponseModel';
import type { WorkshopcheckOutCheckListCheckInput } from '../models/WorkshopcheckOutCheckListCheckInput';
import type { WorkshopCheckOutCustomerDetailsModel } from '../models/WorkshopCheckOutCustomerDetailsModel';
import type { WorkshopCheckOutDetailedModel } from '../models/WorkshopCheckOutDetailedModel';
import type { WorkshopCheckOutFilterType } from '../models/WorkshopCheckOutFilterType';
import type { WorkshopCheckOutLogModelPagedListData } from '../models/WorkshopCheckOutLogModelPagedListData';
import type { WorkshopCheckOutPreviewModel } from '../models/WorkshopCheckOutPreviewModel';
import type { WorkshopCheckOutSubmitModel } from '../models/WorkshopCheckOutSubmitModel';
import type { WorkshopCheckOutUpdateModel } from '../models/WorkshopCheckOutUpdateModel';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WorkshopCheckOutService {

  /**
   * @param branchId 
   * @param type
 *
 * 0 = CheckIn
 *
 * 1 = CheckOut
   * @param bookingType
 *
 * 0 = Service
 *
 * 1 = Investigation
 *
 * 2 = Recall
 *
 * 3 = Repair
 *
 * 4 = MOT
   * @param transportOption
 *
 * 1 = StandartBooking
 *
 * 2 = WhileYouWait
 *
 * 3 = CollectionAndelivery
 *
 * 4 = LoanCar
 *
 * 5 = Recovery
   * @param wipNo 
   * @param regNo 
   * @param dateFrom 
   * @param dateTo 
   * @param skipPagination Пропустить пагинацию
   * @param page Страница
   * @param maxCount Максимально количество записей на странице
   * @returns WorkshopCheckOutLogModelPagedListData Success
   * @throws ApiError
   */
  public static getWorkshopCheckOut(
branchId: number,
type: WorkshopCheckOutFilterType,
bookingType?: BookingType,
transportOption?: NewTransportOptionEnum,
wipNo?: number,
regNo?: string,
dateFrom?: string,
dateTo?: string,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<WorkshopCheckOutLogModelPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop-check-out',
      query: {
        'BranchId': branchId,
        'Type': type,
        'BookingType': bookingType,
        'TransportOption': transportOption,
        'WipNo': wipNo,
        'RegNo': regNo,
        'DateFrom': dateFrom,
        'DateTo': dateTo,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postWorkshopCheckOut(
requestBody?: WorkshopCheckOutSubmitModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop-check-out',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @returns WorkshopCheckOutPreviewModel Success
   * @throws ApiError
   */
  public static getWorkshopCheckOutPreview(
soHeaderId: number,
): CancelablePromise<WorkshopCheckOutPreviewModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop-check-out/{soHeaderId}/preview',
      path: {
        'soHeaderId': soHeaderId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns WorkshopCheckOutDetailedModel Success
   * @throws ApiError
   */
  public static getWorkshopCheckOut1(
id: number,
): CancelablePromise<WorkshopCheckOutDetailedModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop-check-out/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static patchWorkshopCheckOut(
id: number,
requestBody?: WorkshopCheckOutUpdateModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/workshop-check-out/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteWorkshopCheckOut(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/workshop-check-out/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @param checkId 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static patchWorkshopCheckOutCheckbox(
id: number,
checkId: number,
requestBody?: WorkshopcheckOutCheckListCheckInput,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/workshop-check-out/{id}/checkbox/{checkId}',
      path: {
        'id': id,
        'checkId': checkId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static patchWorkshopCheckOutCustomerDetails(
id: number,
requestBody?: WorkshopCheckOutCustomerDetailsModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/workshop-check-out/{id}/customer-details',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param formData 
   * @returns any Success
   * @throws ApiError
   */
  public static postWorkshopCheckOutPhoto(
id: number,
formData?: {
files?: Array<Blob>;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop-check-out/{id}/photo',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param photo 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteWorkshopCheckOutPhoto(
id: number,
photo: string,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/workshop-check-out/{id}/photo/{photo}',
      path: {
        'id': id,
        'photo': photo,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @param formData 
   * @returns WorkshopCheckInUploadedVideoResponseModel Created
   * @throws ApiError
   */
  public static postWorkshopCheckOutVideo(
id: number,
formData?: {
Video: Blob;
},
): CancelablePromise<WorkshopCheckInUploadedVideoResponseModel> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop-check-out/{id}/video',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteWorkshopCheckOutVideo(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/workshop-check-out/{id}/video',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postWorkshopCheckOutCdkCheckOut(
id: number,
requestBody?: WorkshopCheckInCDKCheckOutCreateModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop-check-out/{id}/cdk-check-out',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

}
